<template>
  <div v-if="auction.start_date" class="ta-auction-view-start_date">
    <b v-if="label" class="ta-auction-start_date-label">{{label}}: </b>
    <span v-if="datetime" class="ta-auction-start_date-value">{{ auction.start_date | datetime }}</span>
    <span v-else class="ta-auction-start_date-value">{{ auction.start_date | date }}</span>
  </div>
</template>

<script>
import auctionViewMixin from "@/mixins/auctionViewMixin";

export default {
  name: "AuctionStartDate",
  props: {
    label: {
      type: [Boolean, String],
      default() {
        return this.$t('Start Date')
      }
    },
    datetime: {
      type: Boolean,
      default: true
    }
  },
  mixins: [auctionViewMixin],
}
</script>

<style lang="scss" scoped>
</style>
